import * as tslib_1 from "tslib";
import { BaseApiClient } from './BaseApiClient';
export var EVENTS_ENDPOINTS = {
    BY_EVENT_ID: '/Events/GetByEventId',
    BY_LEAGUE_ID: '/Events/GetByLeagueId',
    BY_SPORT_ID: '/Events/GetBySportId',
    BY_EVENT_ID_OR_BY_LEAGUE_ID: '/Events/GetByEventIdOrByLeagueId',
    FROM_TOP_LEAGUES_BY_SPORT_ID: '/Events/GetFromTopLeaguesBySportId',
    COUNT_BY_TAG: '/Events/GetCountByTag'
};
/**
 * EventsApiClient - client for fetching Leagues BFF endpoints
 * @export
 * @class EventsApiClient
 * @extends {BaseApiClient}
 */
var EventsApiClient = /** @class */ (function (_super) {
    tslib_1.__extends(EventsApiClient, _super);
    function EventsApiClient() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Fetch events by ids from BFF
     * @param {request} EventsByEventIdRequest
     * @throws {RequiredError}
     * @memberof EventsApiClient
     */
    EventsApiClient.prototype.getByEventsId = function (request) {
        var fetchOptions = {
            request: request,
            fetchOptOverride: {}
        };
        return this.executeRequest(EVENTS_ENDPOINTS.BY_EVENT_ID, fetchOptions);
    };
    /**
     * Fetch events by league ids from BFF
     * @param {request} EventsByLeagueIdRequest
     * @throws {RequiredError}
     * @memberof EventsApiClient
     */
    EventsApiClient.prototype.getByLeaguesId = function (request) {
        var fetchOptions = {
            request: request,
            fetchOptOverride: {}
        };
        return this.executeRequest(EVENTS_ENDPOINTS.BY_LEAGUE_ID, fetchOptions);
    };
    /**
     * Fetch events by sport ids from BFF
     * @param {request} EventsBySportIdRequest
     * @throws {RequiredError}
     * @memberof EventsApiClient
     */
    EventsApiClient.prototype.getBySportId = function (request) {
        var fetchOptions = {
            request: request,
            fetchOptOverride: {}
        };
        return this.executeRequest(EVENTS_ENDPOINTS.BY_SPORT_ID, fetchOptions);
    };
    /**
     * Fetch events from top leagues by sport id from BFF
     * @param {request} EventsFromTopLeaguesBySportIdRequest
     * @throws {RequiredError}
     * @memberof EventsApiClient
     */
    EventsApiClient.prototype.getFromTopLeaguesBySportId = function (request) {
        var fetchOptions = {
            request: request,
            fetchOptOverride: {}
        };
        return this.executeRequest(EVENTS_ENDPOINTS.FROM_TOP_LEAGUES_BY_SPORT_ID, fetchOptions);
    };
    /**
     * Fetch events count by tag from BFF
     * @param {request} EventsCountByTagRequest
     * @throws {RequiredError}
     * @memberof EventsApiClient
     */
    EventsApiClient.prototype.getCountByTag = function (request) {
        var fetchOptions = {
            request: request,
            fetchOptOverride: {}
        };
        return this.executeRequest(EVENTS_ENDPOINTS.COUNT_BY_TAG, fetchOptions);
    };
    /**
     * Fetch events by event Ids or by league Ids from BFF
     * @param {request} EventsByEventIdOrByLeagueIdRequest
     * @throws {RequiredError}
     * @memberof EventsApiClient
     */
    EventsApiClient.prototype.getByEventIdOrByLeagueId = function (request) {
        var fetchOptions = {
            request: request,
            fetchOptOverride: {}
        };
        return this.executeRequest(EVENTS_ENDPOINTS.BY_EVENT_ID_OR_BY_LEAGUE_ID, fetchOptions);
    };
    return EventsApiClient;
}(BaseApiClient));
export { EventsApiClient };
//# sourceMappingURL=EventsApiClient.js.map